import React from "react";

const embed = id => `https://youtube.com/embed/${id}`;

const youtubeId = url => {
  return url.split("?v=")[1];
};

export const YoutubeEmbed = url => embed(youtubeId(url));

const iframeUrl = props =>
  `${YoutubeEmbed(props.url)}?controls=0&showinfo=0&autoplay=true` +
  (props.loop ? `&playlist=${youtubeId(props.url)}&loop=1}` : "");

export const YoutubeComponent = props =>
  <iframe
    title="Youtube"
    style={props}
    frameBorder="0"
    allowFullScreen
    src={iframeUrl(props)}
    onClick={e => {
      e.preventDefault();
      e.stopPropagation();
    }}
  />;



// WEBPACK FOOTER //
// ./src/spreadsheet/providers/youtube.js